import { isValidIBAN } from 'ibantools';

const regex = /^FI\d{16}$/;

export const validateFinnishAccountNumber = (
  accountNumber: string
): boolean => {
  if (!accountNumber) return false;

  return regex.test(accountNumber) && isValidIBAN(accountNumber);
};
